import { motion } from "framer-motion";
import { ArrowDown, Play } from "lucide-react";
import { RevealLines } from "./Reveal";
import { StraightCard } from "./StraightCard";
import { EASE } from "../data";
import { useModal } from "../context/ModalContext";

export const Hero = () => {
  const { openContact } = useModal();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#f5f5f7] text-black pt-28 md:pt-32"
    >
      <div
        className="absolute top-1/4 -right-40 w-[520px] h-[520px] rounded-full opacity-[0.06] blur-[120px]"
        style={{ background: "var(--primary-accent)" }}
      />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-center min-h-[calc(100vh-8rem)]">
          <div className="lg:col-span-7">
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: EASE }}
              className="inline-flex items-center gap-2 rounded-full border bg-white px-4 py-1.5 mb-8"
              style={{ borderColor: "var(--border-light)" }}
            >
              <span
                className="w-2 h-2 rounded-full"
                style={{ background: "var(--primary-accent)" }}
              />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-black/60">
                Spend stablecoins. Like cash.
              </span>
            </motion.div> */}

            <h1 className="font-display text-black text-6xl md:text-8xl lg:text-[110px] font-extrabold tracking-tighter leading-[0.92]">
              <RevealLines lines={["The", "Stablecoin", "Card Network."]} />
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: EASE, delay: 0.6 }}
              className="mt-8 max-w-xl text-base md:text-lg text-black/55 leading-relaxed"
            >
              Pay anywhere cards are accepted—without top-ups, custodial
              accounts, or giving up control of your assets. Keep your crypto.
              Spend it when you need it.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: EASE, delay: 0.75 }}
              className="mt-10 flex flex-wrap items-center gap-4"
            >
              <button
                data-testid="hero-contact-btn"
                onClick={openContact}
                className="inline-flex items-center gap-2 rounded-full bg-black text-white text-sm font-semibold px-8 py-4 hover:scale-105 transition-transform duration-300"
              >
                Contact
              </button>
              <button
                data-testid="hero-watch-demo-btn"
                onClick={() => scrollTo("products")}
                className="inline-flex items-center gap-2 rounded-full border bg-white px-7 py-4 text-sm font-semibold text-black hover:bg-black/[0.03] transition-colors duration-300"
                style={{ borderColor: "var(--border-light)" }}
              >
                <Play size={15} className="fill-black text-black" /> Watch demo
              </button>
            </motion.div>
          </div>

          <div className="lg:col-span-5">
            <StraightCard />
          </div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-black/40"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <ArrowDown size={16} className="animate-bounce" />
      </motion.div>
    </section>
  );
};
